import axios from 'axios';

const getLocaisEntrega = params => axios.get('/locais-entrega', { params });

export default {
  getLocaisEntrega,
};
